import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class OrgaoExternoService extends Service {
  async consultarOrgaosExternos () {
    let orgaosExternos = [];
    let result = await this.getOrgaoExternoApi().consultarOrgaosExternos();
    orgaosExternos = result;
    return orgaosExternos;
  }
}

export default OrgaoExternoService;
